import { render, staticRenderFns } from "./CellPhoneIcon.vue?vue&type=template&id=57b78183&"
import script from "./CellPhoneIcon.vue?vue&type=script&lang=js&"
export * from "./CellPhoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports